import React, { memo } from 'react'
import styles from '../styles.module.scss'

interface FlowerHeaderProps {
  canContinue: boolean
  selectedCount: number
  minRequired: number
  onContinue: () => void
  isSaving?: boolean
}

/* eslint-disable react/prop-types */
const FlowerHeader = memo<FlowerHeaderProps>(
  ({ canContinue, selectedCount, minRequired, onContinue, isSaving = false }) => (
    <div className={styles.flowerleftSection}>
      <div className={styles.textContent}>
        <div className={styles.titleContainer}>
          <h1 id="flower-selection-title" className={styles.title}>
            Select the flowers that make you swoon.
          </h1>
          <p className={styles.flowerSubtitle}>Decisions are hard. Pick 7 or more to get started.</p>
        </div>
        <button
          className={
            `${styles.continueButton} ` + (isSaving ? styles.saving : selectedCount >= 7 ? styles.validSelection : '')
          }
          onClick={onContinue}
          disabled={!canContinue || isSaving}
          aria-disabled={!canContinue || isSaving}
        >
          {isSaving ? <span className={styles.savingText}>Saving...</span> : 'CONTINUE'}
        </button>
        <p className={styles.subtitle}>
          {selectedCount === 0 ? `0 of ${minRequired} selected` : `${selectedCount} of ${minRequired} selected`}
        </p>
      </div>
      {/* Mobile-only Continue Button and Subtitle */}
      <div className={styles.continueMobileContainer}>
        <p className={styles.subtitleMobile}>
          {selectedCount === 0 ? `0 of ${minRequired} selected` : `${selectedCount} of ${minRequired} selected`}
        </p>
        <button
          className={
            `${styles.continueButtonMobile} ` +
            (isSaving ? styles.saving : selectedCount >= 7 ? styles.validSelection : '')
          }
          onClick={onContinue}
          disabled={!canContinue || isSaving}
          aria-disabled={!canContinue || isSaving}
        >
          {isSaving ? <span className={styles.savingText}>Saving...</span> : 'CONTINUE'}
        </button>
      </div>
    </div>
  )
)

FlowerHeader.displayName = 'FlowerHeader'

export default FlowerHeader
